"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMPT_MAKER_ERROR_CODES = void 0;
exports.PROMPT_MAKER_ERROR_CODES = {
    INVALID_PARAMETERS: 'INVALID_PARAMETERS',
    NON_PROMPT: 'NON_PROMPT',
};
